import React, { Component } from "react"


// availity-reactstrap-validation
import { Link } from "react-router-dom"

import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"

// import images
import logoImg from "../../assets/images/logo.svg"
import profileImg from "../../assets/images/profile-img.png"


class LockScreen extends Component {
  constructor(props) {
    super(props);
    this.state ={};
  }
  render() {
    return (
      <React.Fragment>
       
            <title>Finagotech | Lock Screen</title>
          
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="fas fa-home h2"/>
          </Link>
        </div>
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md="8" lg="6" xl="5">
                <Card className="overflow-hidden">
                  <div className="bg-primary bg-soft">
                    <Row>
                      <Col xs="7">
                        <div className="text-primary p-4">
                          <h5 className="text-primary">Lock screen</h5>
                          <p>Enter your password to unlock the screen!</p>
                        </div>
                      </Col>
                      <Col xs="5" className="align-self-end">
                        <img src={profileImg} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div>
                      <Link to="/">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logoImg}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="p-2">
                     
                        <div className="text-end">
                          <Col xs="12" className="text-end">
                            <Button
                              color="primary"
                              className=" w-md"
                              type="submit"
                              onClick={()=>window.location.href ="/Dashboard"}
                            >
                              Unlock
                            </Button>
                          </Col>
                        </div>
                    
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p>
                    Not you ? return{" "}
                    <Link
                      to="/login"
                      className="fw-medium text-primary"
                    >
                      {" "}
                      Sign In{" "}
                    </Link>{" "}
                  </p>
                  <div className="mt-5 text-center">
                  
                  <p>
                    © {new Date().getFullYear()}  Finagotech 
                  </p>
                </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default LockScreen
